/**
 * Centralized API endpoint constants
 * This file contains all API endpoint paths used across the application
 */

// ============================================================================
// PAYMENT & CHECKOUT ENDPOINTS
// ============================================================================

export const PAYMENT_ENDPOINTS = {
  // Checkout
  CREATE_CHECKOUT_SESSION: '/api/v1/create-checkout-session',
  ENTERPRISE_CREATE_CHECKOUT_SESSION: '/api/v1/enterprise/create-checkout-session',
  SESSION_STATUS: '/api/v1/session-status',
  LIST_PRICES: '/api/v1/prices',

  // Subscriptions
  CURRENT_SUBSCRIPTION: '/api/v1/subscriptions/current',
  ORGANIZATION_SUBSCRIPTION: '/api/v1/subscriptions/organization',
  UPDATE_SUBSCRIPTION: '/api/v1/subscriptions/update',
  CANCEL_SUBSCRIPTION: '/api/v1/subscriptions/cancel',
  CREATE_PORTAL_SESSION: '/api/v1/subscriptions/create-portal-session',
  CREATE_PORTAL_SESSION_UPGRADE: '/api/v1/subscriptions/create-portal-session-upgrade',

  // Payment Methods
  PAYMENT_METHODS: '/api/v1/subscriptions/payment-methods',
  SETUP_INTENT: '/api/v1/subscriptions/payment-methods/setup-intent',
  ATTACH_PAYMENT_METHOD: '/api/v1/subscriptions/payment-methods/attach',
  SET_DEFAULT_PAYMENT_METHOD: (paymentMethodId: string) =>
    `/api/v1/subscriptions/payment-methods/${paymentMethodId}/set-default`,
  REMOVE_PAYMENT_METHOD: (paymentMethodId: string) =>
    `/api/v1/subscriptions/payment-methods/${paymentMethodId}`,

  // Invoices
  INVOICES: '/api/v1/invoices',
  UPCOMING_INVOICE: '/api/v1/invoices/upcoming',
  INVOICE_DETAILS: (invoiceId: string) => `/api/v1/invoices/${invoiceId}`,
  INVOICE_PDF: (invoiceId: string) => `/api/v1/invoices/${invoiceId}/pdf`,

  // Enterprise Billing (Organization-level)
  ENTERPRISE_CURRENT_SUBSCRIPTION: '/api/v1/subscriptions/enterprise/current',
  ENTERPRISE_UPDATE_SUBSCRIPTION: '/api/v1/subscriptions/enterprise/update',
  ENTERPRISE_CANCEL_SUBSCRIPTION: '/api/v1/subscriptions/enterprise/cancel',
  ENTERPRISE_CREATE_PORTAL_SESSION: '/api/v1/subscriptions/enterprise/create-portal-session',
  ENTERPRISE_CREATE_PORTAL_SESSION_UPGRADE:
    '/api/v1/subscriptions/enterprise/create-portal-session-upgrade',
  ENTERPRISE_PAYMENT_METHODS: '/api/v1/subscriptions/enterprise/payment-methods',
  ENTERPRISE_SETUP_INTENT: '/api/v1/subscriptions/enterprise/create-setup-intent',
  ENTERPRISE_ATTACH_PAYMENT_METHOD: '/api/v1/subscriptions/enterprise/attach-payment-method',
  ENTERPRISE_SET_DEFAULT_PAYMENT_METHOD:
    '/api/v1/subscriptions/enterprise/set-default-payment-method',
  ENTERPRISE_REMOVE_PAYMENT_METHOD: (paymentMethodId: string) =>
    `/api/v1/subscriptions/enterprise/payment-methods/${paymentMethodId}`,
  ENTERPRISE_INVOICES: '/api/v1/invoices/enterprise',
  ENTERPRISE_UPCOMING_INVOICE: '/api/v1/invoices/enterprise/upcoming',
  ENTERPRISE_INVOICE_DETAILS: (invoiceId: string) => `/api/v1/invoices/enterprise/${invoiceId}`,
  ENTERPRISE_INVOICE_PDF: (invoiceId: string) => `/api/v1/invoices/enterprise/${invoiceId}/pdf`,
} as const;

export const CHAT_ENDPOINTS = {
  NEW_SESSION: '/api/v1/chat/sessions/new',
} as const;

export const EXPORT_ENDPOINTS = {
  FORMS: '/api/v1/export/forms/export',
} as const;
